// Call from the Follow gesture, before service-worker or network awaits.
export function requestFollowPermission(notifications = window.Notification) {
  if (!notifications)
    return Promise.reject(
      Object.assign(
        new Error(
          'Browser notifications are not supported here. Open this page in a supported browser.'
        ),
        { code: 'push/unsupported' }
      )
    );
  if (
    notifications.permission === 'granted' ||
    notifications.permission === 'denied'
  )
    return Promise.resolve(notifications.permission);
  return notifications.requestPermission();
}

export function followErrorMessage(error, permission) {
  if (error?.code === 'push/unsupported')
    return 'This browser cannot receive web push notifications. Open this page in Chrome, Edge, Firefox or Safari to follow.';
  if (permission === 'denied')
    return 'Notifications are blocked for this site. Allow them in this browser’s site settings, then try Follow again.';
  if (permission !== 'granted')
    return 'Notification permission was not granted. Tap Follow again and choose Allow.';
  if (error?.code === 209)
    return 'Your session has expired. Refresh this page and try following again.';
  if (error?.followStage === 'subscription')
    return 'Notifications are allowed, but your subscription could not be saved. Please try again.';
  return 'Notifications are allowed, but this browser could not register for push notifications. Please try again or open this page in Chrome, Edge, Firefox or Safari.';
}
